import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Line, Link } from './disclaimer.styles';
import messages from './messages';

export class Disclaimer extends PureComponent {
  static propTypes = {
    closeKeyboard: PropTypes.func.isRequired,
    showPolicy: PropTypes.func.isRequired,
    showTerms: PropTypes.func.isRequired,
  };

  handleTermsClick = () => {
    this.props.closeKeyboard();
    this.props.showTerms();
  };
  handlePolicyClick = () => {
    this.props.closeKeyboard();
    this.props.showPolicy();
  };

  renderTermsLink = () => (
    <Link onClick={this.handleTermsClick}>
      <FormattedMessage {...messages.termsLinkLabel} />
    </Link>
  );

  renderPolicyLink = () => (
    <Link onClick={this.handlePolicyClick}>
      <FormattedMessage {...messages.policyLinkLabel} />
    </Link>
  );

  render() {
    return (
      <Container>
        <Line>
          <FormattedMessage
            {...messages.topLine}
            values={{ termsLink: this.renderTermsLink(), policyLink: this.renderPolicyLink() }}
          />
        </Line>
        <Line>
          <FormattedMessage {...messages.bottomLine} />
        </Line>
      </Container>
    );
  }
}
